import {
  ALLOWED_LABEL_NAV_ITEMS, COUNTERTOP_LABELS,
  FEATURES_WITH_0_VALUE_FOR_THE_SLABS,
  MEASURE_UNITS,
  SHAPE_PART_ID,
  SQFT_FEATURES
} from "../../sqft/constants";
import {
  FEATURE_STONE,
  getFeatureType,
  getFeatureUnit,
  getSlabUnit,
  calculateStoneCost,
  getRoomName, getSlabsFeatureGroup
} from "../../../misc/helpers";
import {getCurrentLayout} from "../../appLayout";
import store from "../../../store";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";
import workspace from "../../sqft/components/canvas/core/workspace";
import {getCommonVisualizerType} from "../../../config";
import {getNavItemsFromTheWizard, getWizardGroupsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
//import {isFeatureUnitUseEach} from "../../sqft/helpers/featureHelper";

/**
 * @param parentKey {string}
 * @param partId {string}
 * @param quoteIndex {number || null}
 * @returns featureGroup {object}
 */
export const getSimilarFeatureGroup = (parentKey, partId, quoteIndex = null) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  let room;
  let qtCategoryName;
  if (quoteIndex !== null && quotes[quoteIndex].room) {
    const activeQuote = quotes[quoteIndex];
    room = activeQuote.room;
    qtCategoryName = quotes[quoteIndex].qtCatName ? quotes[quoteIndex].qtCatName : getRoomNameInQuote(quoteIndex);
  }
  const layout = getCurrentLayout(room);
  if (!layout) {
    return null
  }

  let featureGroup = null;
  let neededPartId = partId;
  switch (parentKey) {
    case "backsplashes": {
      const isBathroom = getCommonVisualizerType() === "bathroom";
      featureGroup = layout.getSubPartFromQtCategories("backsplash", qtCategoryName, true);
      if (!featureGroup && isBathroom) {
        featureGroup = layout.getSubPartFromQtCategories(SQFT_FEATURES.vanity_backsplash, qtCategoryName);
      }
      neededPartId = isBathroom ? SQFT_FEATURES.vanity_backsplash : "backsplash";
      break;
    }
    case "edges": {
      const mainNeeded = parentKey === "center_island_countertop" ? "center_island_edge" : "edge_profile";
      const oppositeNeeded = mainNeeded === "center_island_edge" ? "edge_profile" : "center_island_edge";
      featureGroup = layout.getSubPartFromQtCategories(mainNeeded, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories(oppositeNeeded, qtCategoryName);
      }
      neededPartId = mainNeeded;
      break;
    }
    case SQFT_FEATURES.slabs: {
      featureGroup = getSlabsFeatureGroup();
      // let countertopsCategory = layout.qtCategories.find(qtCategory => {
      //   return qtCategory.name === "Countertops" || qtCategory.name === "Countertop"
      // });
      //countertopsCategory = countertopsCategory === undefined ? layout.qtCategories[0] : countertopsCategory;

      //let subParts = countertopsCategory.subParts;
      //const subPartSlab = subParts.find(designNavigationItem => designNavigationItem.part.partId === SQFT_FEATURES.slabs);
      //if (!subPartSlab) {
        //subParts.splice(2, 0, featureGroup);
        //countertopsCategory.subParts = subParts;
      //}

      break;
    }
    case "countertop":
    case "center_island_countertop": {
      const oppositeNeeded = partId === "center_island_countertop" ? "countertop" : "center_island_countertop";
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories(oppositeNeeded, qtCategoryName);
      }
      break;
    }
    case "corners": {
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories('radius', qtCategoryName);
      }
      break;
    }
    default:
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      break;
  }
  if (!featureGroup) {
    const foundGroup = layout.getFeatureGroupByPartId(neededPartId);
    if (foundGroup) {
      featureGroup = {part: foundGroup}
    }
  }
  return featureGroup
};

/**
 * @returns {string}
 */
export const getRoomNameInQuote = (quoteIndex) => {
  const state = store.getState();
  const {quotes} = state.quotesState;
  const fabricatorData = state.fabricatorState;
  const cartItems = state.cartState.cartItems;
  const intl = workspace.intl;

  return getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
}

/**
 * @param {{}} parentsList
 * @returns {boolean}
 */
export const isRecalculateSlabNeeded = (parentsList) => {
  const useStonePricing = Object.keys(parentsList).some(parentKey => {
    if (!parentsList[parentKey] || !parentsList[parentKey].features) {
      return false
    }
    return parentsList[parentKey].features.some((sqftFeature) => {
      if (sqftFeature.feature && (FEATURE_STONE === getFeatureType(sqftFeature.feature.dbFeature))) { // dbFeature stone pricing algorithms related
        const {serverState, fabricatorState, cartState} = store.getState();
        // here we are checking if we should calculate algorithm or not
        // (if not - it should be counted as a regular feature, so it should be no grouping and included logic then)
        const stoneCost = calculateStoneCost(
          sqftFeature.feature.dbFeature,
          sqftFeature.initialQuantity,
          serverState.stonePricing,
          fabricatorState.stoneSupplier,
          false,
          fabricatorState.settings,
          cartState,
        );
        return !!stoneCost;
      }
      return false
    })
  })
  const useSlabImagePricing = parentsList.slabs.features.length > 0;

  return useStonePricing || useSlabImagePricing
}

/**
 * @param parentList {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const recalculateSlabs = (parentList, firstOpen = false) => {
  const state = store.getState();
  const fabricatorSettings = state.fabricatorState.settings;
  let updatedParentList;
  if (fabricatorSettings.useCategorySwitching) {
    updatedParentList = splitPriceBetweenSlabsMaterial(parentList); // will divide total price between shapes
  } else {
    updatedParentList = setPriceIntoSingleFeature(parentList, firstOpen); // will display included price
  }

  return updatedParentList;
};

/**
 * @param sqftFeatures {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const setPriceIntoSingleFeature = (sqftFeatures, firstOpen = false) => {
  let commonSharedFeatureNames = getCommonSharedFeatureNames(sqftFeatures); // {sharedName: "", totalQuantity: 0, biggestFeature, sqftFeatures: []}
  if (commonSharedFeatureNames.length) {  // 2) set each feature new fake quantity
    commonSharedFeatureNames.forEach(sharedObject => {
      sharedObject.sqftFeatures.forEach(sqftFeature => {
        const {fabricatorState} = store.getState();
        if (fabricatorState.isCaesarStone) {
          if (firstOpen) {
            if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
              sqftFeature.sortOrder = 1;
            } else {
              sqftFeature.sortOrder = 0;
            }
          }
        } else {
          //QCDES-1507 calculates slab algorithm pricing
          sqftFeature.displayFakeQuantity = sqftFeature.initialQuantity; // removed for CAESARSTONE, don't know about the others
          if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
            sqftFeature.quantity = sharedObject.totalQuantity; // removed for CAESARSTONE, don't know about the others
            if (firstOpen) {
              sqftFeature.sortOrder = 1;
            }
            sqftFeature.isBiggestFeature = true;
          } else {
            // removed for CAESARSTONE, don't know about the others
            sqftFeature.quantityRounded = 0;
            sqftFeature.quantity = 0;
            sqftFeature.isQuantityAddedToBiggestFeature = true;
            if (firstOpen) {
              sqftFeature.sortOrder = 0;
            }
          }
        }
      });
    });
    if (firstOpen) {
      sqftFeatures = sortSqftFeatures(sqftFeatures);
    }
  }
  console.log("commonSharedFeatureNames", commonSharedFeatureNames);
  return sqftFeatures
};

const createSqftFeaturesObj = () => {
  let sqftFeaturesObj = {};
  for (const availablePartIdsKey in SQFT_FEATURES) {
    sqftFeaturesObj[availablePartIdsKey] = {
      subPart: null,
        features: []
    }
  }

  return sqftFeaturesObj;
}

/**
 * @param sqftFeatures {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const splitPriceBetweenSlabsMaterial = (sqftFeatures, firstOpen = false) => {
  let commonSharedFeatureNames = getCommonSharedFeatureNames(sqftFeatures);
  if (commonSharedFeatureNames.length) {
    commonSharedFeatureNames.forEach(sharedObject => {
      sharedObject = sortSharedObject(sharedObject, firstOpen);
      updateSharedObjectWithGroupQuantity(sharedObject);
    });
    if (firstOpen) {
      sqftFeatures = sortSqftFeatures(sqftFeatures);
    }
  }
  console.log("commonSharedFeatureNames", commonSharedFeatureNames);
  return sqftFeatures
};

const sortSqftFeatures = (sqftFeatures) => {
  Object.keys(sqftFeatures).forEach(parentKey => {
    if (sqftFeatures[parentKey]
      && sqftFeatures[parentKey].features
      && parentKey !== "edges"
    ) {
      sqftFeatures[parentKey].features = sqftFeatures[parentKey].features.sort((a, b) => b.sortOrder - a.sortOrder);
    }
  })

  return sqftFeatures
}
/**
 * @return array of objects [{sharedName: string, totalQuantity: number, biggestFeature: feature, sqftFeatures: []}]
 */
const getCommonSharedFeatureNames = (sqftFeatures) => {
  let commonSharedFeatureNames = [];
  Object.keys(sqftFeatures).forEach(parentKey => { // 1) create common objects and find the biggest feature
    if (sqftFeatures[parentKey]
      && sqftFeatures[parentKey].features
      && parentKey !== "edges"
      && parentKey !== "slabs"
    ) {
      sqftFeatures[parentKey].features.forEach(sqftFeature => {
        if (sqftFeature.feature && Array.isArray(sqftFeature.feature.dbFeature.stonePricingId)
          && sqftFeature.feature.dbFeature.stonePricingId.length) {
          const alreadyAdded = commonSharedFeatureNames.find(sharedObject => {
            return sharedObject.sharedName === sqftFeature.feature.dbFeature.sharedFeatureName
          });
          if (!alreadyAdded) {
            commonSharedFeatureNames.push({
              sharedName: sqftFeature.feature.dbFeature.sharedFeatureName,
              totalQuantity: sqftFeature.disabled ? 0 : sqftFeature.initialQuantity,
              sqftFeatures: [sqftFeature],
              biggestFeature: sqftFeature.disabled ? null : sqftFeature,
            })
          } else {
            alreadyAdded.sqftFeatures.push(sqftFeature);
            if (!sqftFeature.disabled) {
              alreadyAdded.totalQuantity += sqftFeature.initialQuantity;
              if (!alreadyAdded.biggestFeature) {
                alreadyAdded.biggestFeature = sqftFeature;
              } else if (sqftFeature.feature.partId === "countertop") {
                if (alreadyAdded.biggestFeature.partId !== "countertop" || (alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity)) {
                  alreadyAdded.biggestFeature = sqftFeature;
                }
              } else if (sqftFeature.feature.partId === "center_island_countertop") {
                if ((alreadyAdded.biggestFeature.partId !== "countertop" && alreadyAdded.biggestFeature.partId !== "center_island_countertop")
                  || (alreadyAdded.biggestFeature.partId === "center_island_countertop" && alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity)) {
                  alreadyAdded.biggestFeature = sqftFeature;
                }
              } else if ((alreadyAdded.biggestFeature.partId !== "countertop") && (alreadyAdded.biggestFeature.partId !== "center_island_countertop")
                && alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity) { // backsplash
                alreadyAdded.biggestFeature = sqftFeature;
              }
            }
          }
        }
      })
    }
  });

  return commonSharedFeatureNames
}
/**
 * set group price foreach sqftFeature inside sharedObject
 * @param sharedObject {object}
 * @returns sharedObject {object}
 */
const updateSharedObjectWithGroupQuantity = (sharedObject) => {
  const quantityPerFeature = sharedObject.totalQuantity / sharedObject.sqftFeatures.length;
  sharedObject.sqftFeatures.forEach(sqftFeature => {
    const {fabricatorState} = store.getState();
    if (!fabricatorState.isCaesarStone) {
      sqftFeature.group = {
        quantityPerFeature: quantityPerFeature,
        totalFeaturesInGroup: sharedObject.sqftFeatures.filter(sqftFeature => !sqftFeature.disabled).length,
        totalQuantity: sharedObject.totalQuantity,
      }
    }
  });

  return sharedObject
}

/**
 * Returns sorted sharedObject
 * @param sharedObject {object}
 * @param firstOpen {boolean}
 * @returns sharedObject {object}
 */
const sortSharedObject = (sharedObject, firstOpen) => {
  sharedObject.sqftFeatures.forEach(sqftFeature => {
    if (firstOpen) {
      if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
        sqftFeature.sortOrder = 1;
      } else {
        sqftFeature.sortOrder = 0;
      }
    }
  });

  return sharedObject
}

/**
 * Returns needed for popup data
 * @param sqftPassedData {object} // it has sqftCalcData - data that comes from sqft
 * @param previouslyAddedSqftFeatures {object}
 * @param intl {object} // react intl instance
 * @param fabricatorData {object}
 * @param cartItems {array}
 * @param sqftFromFeature {object}
 * @param quoteIndex {number}
 * @param visualizerType {string}
 * @param stonePricing {object}
 * @returns sqftFeatures {object}
 */
export function getParsedSqftData (
  sqftPassedData,
  previouslyAddedSqftFeatures,
  intl,
  fabricatorData,
  cartItems,
  sqftFromFeature,
  quoteIndex,
  visualizerType,
  stonePricing,
) {
  let sqftFeatures = createSqftFeaturesObj();

  if (!sqftPassedData || !sqftPassedData.countertops) {
    return sqftFeatures
  }

  const layout = getCurrentLayout(visualizerType);
  // const firstEdge = sqftPassedData.countertops ? sqftPassedData.countertops.filter(shape => shape.type === "edge")[0] : null
  // if (firstEdge) {
  //   const featureGroup = getSimilarFeatureGroup("edges", firstEdge.partId);
  //   if (featureGroup) {
  //     let navRequests = NavigationRequests();
  //     await navRequests.checkIfAllFeaturesReceived(featureGroup, "", null)
  //   }
  // }
  let isFromCartFeatureAdded = false;
  let feature = null;

  const state = store.getState();
  const isSlabPricingEnabled = state.sqftSlabState.isSlabPricingEnabled;

  Object.keys(sqftFeatures).forEach(parentKey => {
    const isCountertop = parentKey === "countertop" || parentKey === "center_island_countertop";
    let featuresPassed = [];

    // Skip adding slab features if slab pricing is disabled;
    if (parentKey === SQFT_FEATURES.slabs && !isSlabPricingEnabled) {
      return;
    }
    if (isCountertop) {
      featuresPassed = prepareCountertopFeaturesPassed(sqftPassedData, layout, parentKey);
    } else if (parentKey === SQFT_FEATURES.slabs) {
      featuresPassed = prepareSlabFeaturesPassed(sqftPassedData.slabImagesTotalArea);
    } else if (parentKey === SQFT_FEATURES.edges || parentKey === SQFT_FEATURES.backsplashes) {
      let shapeType;
      switch (parentKey) {
        case "edges":
          shapeType = "edge";
        break;
        case "backsplashes":
          shapeType = "backsplash"
        break;
        default:
          shapeType = parentKey
        break;
      }

      if (sqftPassedData.manualCalculate) {
        featuresPassed = prepareEdgesAndBacksplashesManual(sqftPassedData, shapeType, featuresPassed);
      } else {
        featuresPassed = prepareEdgesAndBacksplashes(sqftPassedData, shapeType, featuresPassed);
      }

      // console.log("featuresPassed edges", featuresPassed);
    // } else {
    //   featuresPassed = sqftPassedData[parentKey]
    } else if (parentKey === SQFT_FEATURES.crown_molding) {
      featuresPassed = prepareCrownMoldings(sqftPassedData, parentKey);
    } else if (parentKey === SQFT_FEATURES.handle && sqftPassedData.controllers && sqftPassedData.controllers.handles) {
      featuresPassed = prepareHandles(sqftPassedData.controllers.handles, parentKey);
    } else if (Object.values(ALLOWED_LABEL_NAV_ITEMS).includes(parentKey)) {
      featuresPassed = prepareOtherCountertops(sqftPassedData.countertops, parentKey);
    } else if (parentKey === SQFT_FEATURES.radius) {
      featuresPassed = prepareRadius(sqftPassedData.radii, parentKey);
    } else if (parentKey === SQFT_FEATURES.corners) {
      featuresPassed = prepareCorners(sqftPassedData.corners, parentKey);
    } else if (parentKey === SQFT_FEATURES.underlayment && sqftPassedData.underlayment && sqftPassedData.underlayment.sections) {
      featuresPassed = prepareUnderlayment(sqftPassedData.underlayment.sections, parentKey);
    } else if (parentKey === SQFT_FEATURES.bumpouts && sqftPassedData.bumpouts) {
      featuresPassed = sqftPassedData.bumpouts
    }

    if (featuresPassed && featuresPassed.length) {
      featuresPassed.forEach(featurePassed => {
        const featureGroup = getSimilarFeatureGroup(parentKey, featurePassed.partId, quoteIndex);
        let isSqftFromFeature = false;
        let fromWizardGroupId = "";
        if (featureGroup) {
          if (!sqftFeatures[parentKey].subPart) {
            sqftFeatures[parentKey].subPart = featureGroup;
          }
          const quantity = getQuantityFromCalculator(parentKey, featurePassed, sqftPassedData);
          const displayFakePrice = getFakePriceFromCalculator(parentKey, featurePassed, sqftPassedData, cartItems, quoteIndex);
          //const displayFakeQuantity = getFakeQuantityFromCalculator(parentKey, featurePassed, sqftPassedData);
          [feature, isSqftFromFeature, isFromCartFeatureAdded, fromWizardGroupId] = getFeatureFromSQFT(
            featurePassed,
            previouslyAddedSqftFeatures,
            featureGroup,
            parentKey,
            quoteIndex,
            isCountertop,
            sqftFromFeature,
            cartItems,
            layout,
            isFromCartFeatureAdded,
          );

          let displayFakeQuantity = parentKey === SQFT_FEATURES.slabs ? featurePassed.totalSlabs : null;
          let displayFakeFeatureGroupName = parentKey === SQFT_FEATURES.slabs ? SQFT_FEATURES.slabs : null;
          const featureToCheckUnit = feature || featureGroup.part.features[0];
          const featureUnit = featureToCheckUnit ? getFeatureUnit(featureToCheckUnit, intl, fabricatorData, quantity) : "";
          const unit = parentKey === SQFT_FEATURES.slabs ? getSlabUnit(featurePassed.totalSlabs, intl) : featureUnit;

          sqftShapeManager.setShapeFeature(featurePassed.id, feature);
          sqftFeatures[parentKey].features.push({
            disabled: featurePassed.isDisabledInPopup || false, //previouslyAddedSqftFeature ? previouslyAddedSqftFeature.disabled : false,
            feature,
            displayFakeFeatureGroupName,
            partId: featurePassed.partId,
            unit,
            subPart: featureGroup,
            //quantity: isFeatureUnitUseEach(feature) ? 1 : quantity,
            quantity: quantity,
            quantityRounded: Math.ceil(quantity),
            displayFakeQuantity: displayFakeQuantity,
            displayFakePrice,
            initialQuantity: quantity,
            sqftId: featurePassed.id,
            qtCatName: featurePassed.qtCatName,
            isSqftFromFeature,
            fromWizardGroupId,
            shouldShowEyeBall: featurePassed.shouldShowEyeBall !== undefined ? featurePassed.shouldShowEyeBall : true,
            shouldUseSlabPricing: featurePassed.shouldUseSlabPricing,
          })
        } else {
          console.log("No feature group added to the QuotingTool", parentKey, featurePassed.partId);
        }
      });
    }
  });

  if (isSlabPricingEnabled && isRecalculateSlabNeeded(sqftFeatures)) {
    sqftFeatures = recalculateSlabs(sqftFeatures, true);
    console.log("stonePricing", stonePricing);
    console.log("fabricatorData.pricingPreset", fabricatorData.pricingPreset);
  }

  console.log("sqftFeatures", sqftFeatures);
  return sqftFeatures
}

/**
 * Returns prepared slabFeatures that comes from sqft
 * @param slabImagesGrouped {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const prepareSlabFeaturesPassed = (slabImagesGrouped) => {
  let featuresPassed = [];
  slabImagesGrouped
    .forEach(slabImagesGroup => {
      const quantity = Math.ceil(slabImagesGroup.totalArea);
      featuresPassed.push(Object.assign({...slabImagesGroup}, {
        partId: SQFT_FEATURES.slabs,
        squareFeet: quantity,
        pricePerArea: slabImagesGroup.pricePerArea,
        shouldUseSlabPricing: slabImagesGroup.shouldUseSlabPricing,
      }));
    });

  return featuresPassed;
}

/**
 * Returns prepared countertops that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param layout {object} // layout
 * @param parentKey {string} // parentKey
 * @returns featuresPassed [array]
 */
const prepareCountertopFeaturesPassed = (sqftPassedData, layout, parentKey) => {
  const countertopExist = layout.getSubPartFromQtCategories("countertop");
  const centerIslandExist = layout.getSubPartFromQtCategories("center_island_countertop");
  let featuresPassed = []
  if (sqftPassedData.manualCalculate) {
    featuresPassed = sqftPassedData.countertops
      .filter(manCountertopObject => manCountertopObject.partId === parentKey)
      .map(manCountertopObject => {
        return {
          id: manCountertopObject.id,
          squareFeet: manCountertopObject.area,
          partId: manCountertopObject.partId
        }
      })
  } else if (sqftPassedData.countertops && sqftPassedData.countertops.length) {
    featuresPassed = sqftPassedData.countertops.filter(shape => {
      if (shape.partId === "countertop" || shape.partId === "center_island_countertop") {
        if (countertopExist && !centerIslandExist) {
          shape.partId = countertopExist.part.partId;
        } else if (centerIslandExist && !countertopExist) {
          shape.partId = centerIslandExist.part.partId;
        }
      }

      return shape.shapeType && (shape.partId === parentKey)
        && !["backsplash", SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.type)
    })
  }

  return featuresPassed;
}

/**
 * Returns other prepared countertops that comes from sqft
 * @param sqftPassedDataCountertops {object} // data that comes from sqft
 * @param parentKey {string} // parentKey
 * @returns featuresPassed [array]
 */
const prepareOtherCountertops = (sqftPassedDataCountertops, parentKey) => {
  return sqftPassedDataCountertops
    .filter(manCountertopObject => manCountertopObject.partId === parentKey)
    .map(manCountertopObject => {
      return {
        id: manCountertopObject.id,
        squareFeet: manCountertopObject.squareFeet,
        partId: manCountertopObject.partId,
        qtCatName: manCountertopObject.qtCatName,
        featureId: manCountertopObject.featureId,
      }
    });
}

/**
 * Returns other prepared radius's that comes from sqft
 * @param sqftPassedDataRadius {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const prepareRadius = (sqftPassedDataRadius) => {
  return sqftPassedDataRadius
    .filter(radiusObject => radiusObject.featureId !== null)
    .map(radiusObject => {
      return {
        id: radiusObject.id,
        qtCatName: radiusObject.qtCatName,
        partId: SQFT_FEATURES.radius,
        featureId: radiusObject.featureId,
        quantity: 1
      }
    });
}

/**
 * Returns other prepared Handlers that comes from sqft
 * @param sqftPassedDataHandler {object} // data that comes from sqft
 * @param parentKey {string}
 * @returns featuresPassed [array]
 */
const prepareHandles = (sqftPassedDataHandler, parentKey) => {
  return sqftPassedDataHandler
    .filter(handlerObject => handlerObject.featureId !== null)
    .map(radiusObject => {
      return {
        id: radiusObject.id,
        qtCatName: radiusObject.qtCatName,
        partId: parentKey,
        featureId: radiusObject.featureId,
        quantity: 1
      }
    });
}

/**
 * Returns other prepared corner's that comes from sqft
 * @param sqftPassedDataRadius {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const prepareCorners = (sqftPassedDataRadius) => {
  return sqftPassedDataRadius
    .filter(radiusObject => radiusObject.featureId !== null)
    .map(radiusObject => {
      return {
        id: radiusObject.id,
        qtCatName: radiusObject.qtCatName,
        partId: SQFT_FEATURES.corners,
        featureId: radiusObject.featureId,
        quantity: 1
      }
    });
}

/**
 * Returns other prepared corner's that comes from sqft
 * @param sqftPassedDataUnderlayment {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const prepareUnderlayment = (sqftPassedDataUnderlayment) => {
  return sqftPassedDataUnderlayment
    //.filter(passedData => passedData.featureId !== null)
    .map(passedData => {
      return {
        id: passedData.id,
        partId: SQFT_FEATURES.underlayment,
        featureId: passedData.featureId,
        qtCatName: passedData.qtCatName,
        quantity: passedData.quantity
      }
    });
}

/**
 * Parse quantity from sqft // todo rewrite and remove this
 * @param parentKey {object} // data that comes from sqft
 * @param featurePassed {object} // data that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const getQuantityFromCalculator = (parentKey, featurePassed, sqftPassedData) => {
  let quantity;
  switch (parentKey) {
    case "edges":
    case "backsplashes":
    case SQFT_FEATURES.crown_molding:
      quantity = sqftPassedData.measureUnit === MEASURE_UNITS.Metric
        ? +(+(featurePassed.length).toFixed(3)).toFixed(2)
        : featurePassed.length
      break
    case SQFT_FEATURES.radius:
    case SQFT_FEATURES.corners:
    case SQFT_FEATURES.handle:
    case SQFT_FEATURES.underlayment:
      quantity = featurePassed.quantity;
      break
    case "countertop":
    case "center_island_countertop":
    case "slabs":
      quantity = featurePassed.squareFeet;
      break
    default:
      if (Object.keys(COUNTERTOP_LABELS).includes(parentKey)) {
        quantity = featurePassed.squareFeet;
      } else {
        quantity = featurePassed.quantity ? featurePassed.quantity : featurePassed.squareFeet;
      }
  }

  return quantity
}

/**
 * Prepare Edges and Backsplashes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @param featuresPassed {array}
 * @returns featuresPassed [array]
 */
const prepareEdgesAndBacksplashes = (sqftPassedData, shapeType, featuresPassed) => {
  sqftPassedData.countertops
    .filter(shape => shape.type === shapeType)
    .forEach(edge => {
      const length = edge.length || edge.squareFeet;
        featuresPassed.push(Object.assign(
          edge, {
          partId: edge.partId || shapeType,
          fromWizardGroupId: edge.fromWizardGroupId, //todo[Anton] this one is not passing here
          length: length,
          qtCatName: edge.qtCatName,
          featureId: edge.backsplashFeatureId ? edge.backsplashFeatureId : edge.featureId,
          shouldShowEyeBall: edge.shouldShowEyeBall !== undefined ? edge.shouldShowEyeBall : true,
        }));
    });

  return featuresPassed
}

/**
 * Prepare CrownMoldings from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @returns featuresPassed [array]
 */
const prepareCrownMoldings = (sqftPassedData, shapeType) => {
  const featuresPassed = [];
  sqftPassedData.countertops
    .filter(shape => shape.type === shapeType)
    .forEach(crownMolding => {
      const length = crownMolding.length || crownMolding.squareFeet;
        featuresPassed.push(Object.assign(
          crownMolding, {
          partId: crownMolding.partId || shapeType,
          length: length,
          qtCatName: crownMolding.qtCatName,
        }));
    });

  return featuresPassed
}

/**
 * Prepare Edges and Backsplashes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @param featuresPassed {array}
 * @returns featuresPassed [array]
 */
const prepareEdgesAndBacksplashesManual = (sqftPassedData, shapeType, featuresPassed) => {
  let sqftData = [];
  switch (shapeType) {
    case "edge":
      sqftData = sqftPassedData.edges;
      break
    case "backsplash":
      sqftData = sqftPassedData.backsplashes;
      break
  }
  sqftData
    .forEach(edge => {
      const edgeLength = edge.length;
      const alreadyAdded = featuresPassed.find(addedEdge => {
        return addedEdge.attachedToParentId && (addedEdge.featureId === edge.featureId)
      });
      if (alreadyAdded) {
        alreadyAdded.length += edgeLength;
      } else {
        featuresPassed.push(Object.assign(edge, {featureId: edge.featureId, partId: edge.partId, length: edgeLength}));
      }
    });

  return featuresPassed
}

/**
 * //todo it is better to rewrite this fake price logic and calculate the price right in the cart
 * Get fake price for display
 * @param parentKey {object} // data that comes from sqft
 * @param featurePassed {object} // data that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param cartItems
 * @param quoteIndex
 * @returns featuresPassed [array]
 */
const getFakePriceFromCalculator = (parentKey, featurePassed, sqftPassedData, cartItems, quoteIndex) => {
  let fakePrice ;
  /** If the number of slabs is greater than one, set the price of all other materials to zero, as only the cost of slabs will be calculated. */
  if (FEATURES_WITH_0_VALUE_FOR_THE_SLABS[parentKey]) {
    const slabAlreadyInTheCart = cartItems.find(cartItem => {
        return (cartItem.sqftId) && (cartItem.partId === SQFT_FEATURES.slabs) && (cartItem.currentQuote === quoteIndex)
      })
    if (sqftPassedData.slabImagesTotalArea.length > 0 || slabAlreadyInTheCart) {
      const activeSlabsExist = sqftPassedData.slabImagesTotalArea.some(slabImageAreaGroup => !slabImageAreaGroup.isDisabledInPopup);
      if (activeSlabsExist) {
        fakePrice = 0;
      }
    }
  /** Applying the hardcoded price for slabs, which was set in the slab popup. */
  } else if (parentKey === SQFT_FEATURES.slabs) {
    if (featurePassed.pricePerArea) {
      fakePrice = parseFloat(featurePassed.pricePerArea) * getQuantityFromCalculator(parentKey, featurePassed, sqftPassedData);
    }
  }

  return fakePrice
}

/**
 * Returns parse sqft passed feature id and returns feature or null
 * @param featurePassed {object} // data that comes from sqft
 * @param parentKey {string} //
 * @param featureGroup {object} featureGroup
 * @param layout {object}
 * @returns feature {object}
 */
const getFeatureFromCalculatorPassedId = (featurePassed, parentKey, featureGroup, layout) => {
  let feature = null;
  let idToFind = null;
  switch (parentKey) {
    case "edges":
    case "backsplashes":
    case "countertop":
    case "center_island_countertop":
    case "slabs":
    case SHAPE_PART_ID.slabPlaceHolder:
      idToFind = +featurePassed.featureId;
      break
    default:
      idToFind = featurePassed.featureId ? featurePassed.featureId: null;
  }
  if (idToFind) {
    feature = layout.getFeatureById(idToFind, true);
    if (!feature && featurePassed.slabParentPartId) {
      const slabParentFeatureGroup = layout.getFeatureGroupByPartId(featurePassed.slabParentPartId);
      if (slabParentFeatureGroup) {
        feature = slabParentFeatureGroup.getFeatureById(featurePassed.featureId, true);
      }
    }
    if (!feature && featurePassed.partId) {
      const slabParentFeatureGroup = layout.getFeatureGroupByPartId(featurePassed.partId);
      if (slabParentFeatureGroup) {
        feature = slabParentFeatureGroup.getFeatureById(featurePassed.featureId, true);
      }
    }
    // const navFeatures = getNavItems(featureGroup);//layout.designNavigationItems(featureGroup, {}, "", false, true);
    //
    // const navFeature = navFeatures.find(navItem => navItem.part.dbFeature.id === idToFind);
    // if (navFeature) {
    //   feature = navFeature.part;
    // } else if (parentKey === "slabs") {
    //   feature = layout.getFeatureById(idToFind);
    // } else if (parentKey === "top_cabinet" || parentKey === "bottom_cabinet") {
    //   feature = layout.getFeatureById(idToFind, true);
    // }
  }

  return feature;
}

/**
 * Returns parse sqft passed feature id and returns feature or null
 * @param featurePassed {object} // data that comes from sqft
 // * @param previouslyAddedSqftFeatures {object} //
 * @param previouslyAddedSqftFeatures
 * @param featureGroup {object} //
 * @param parentKey {string} //
 * @param activeQuoteIndex {number} //
 * @param isCountertop {boolean} //
 * @param sqftFromFeature {object} //
 * @param cartItems {object} //
 * @param layout {object} //
 * @param isFromCartFeatureAdded {boolean} //
 * @returns feature {object}
 */
const getFeatureFromSQFT = (
  featurePassed,
  previouslyAddedSqftFeatures,
  featureGroup,
  parentKey,
  activeQuoteIndex,
  isCountertop,
  sqftFromFeature,
  cartItems,
  layout,
  isFromCartFeatureAdded,
) => {
  let isSqftFromFeature = false;
  const previouslyAddedSqftFeature = previouslyAddedSqftFeatures.find(existing => {
    return featurePassed.id && (existing.sqftId === featurePassed.id) && (existing.currentQuote === activeQuoteIndex)
  });
  let feature = getFeatureFromCalculatorPassedId(featurePassed, parentKey, featureGroup, layout);

  if (cartItems.length && !feature) {
    const alreadyAdded = cartItems.find(cartItem => {
      return (cartItem.sqftId) && (cartItem.sqftId === featurePassed.id) && (cartItem.currentQuote === activeQuoteIndex)
    })
    const hasSamePartIdWithCartFeature = alreadyAdded && featureGroup.part.partId === alreadyAdded.cartFeature.partId
    if (hasSamePartIdWithCartFeature) {
      feature = alreadyAdded.cartFeature;
    }
  }

  const hasSamePartIdWithPreviouslyAddedFeature = previouslyAddedSqftFeature && previouslyAddedSqftFeature.partId === featureGroup.part.partId
  if (!feature && hasSamePartIdWithPreviouslyAddedFeature) {
    feature = previouslyAddedSqftFeature.feature;
  }
  if (!feature && (isCountertop || parentKey === "backsplashes") && sqftFromFeature
    && (sqftFromFeature.cartFeature.partId === featureGroup.part.partId)) {
    feature = sqftFromFeature.cartFeature;
    if (!isFromCartFeatureAdded) {
      isSqftFromFeature = true;
    }
    isFromCartFeatureAdded = true;
  }

  const state = store.getState();
  const {wizardActiveItem, wizardIsActive} = state.wizardState;

  let fromWizardGroupId = featurePassed.fromWizardGroupId;

  if (!fromWizardGroupId && wizardIsActive && wizardActiveItem) {
    const featureGroup = layout.getFeatureGroupByPartId(featurePassed.partId);
    if (featureGroup) {
      const wizardSteps = getWizardGroupsFromTheWizard(featureGroup.dbName || featureGroup.partName);
      if (wizardSteps.length) {
        // we don't set it to featurePassed, as we need to have all navItems in the dropdown, here we just find
        // at least something from the wizard
        fromWizardGroupId = wizardSteps[0].stepGroups[0].id;
      }
    }
  }

  const allNavItems = fromWizardGroupId
    ? getNavItemsFromTheWizard(featureGroup, "", {}, fromWizardGroupId)
    : layout.designNavigationItems(featureGroup, {}, "", false, true);

  // console.log("allNavItems", allNavItems);

  if (!feature && sqftFromFeature && (
    ((parentKey === "backsplashes") && sqftFromFeature.cartFeature.partId.includes("countertop"))
    || (isCountertop && sqftFromFeature.cartFeature.partId.includes("backsplash"))
    || (isCountertop && sqftFromFeature.cartFeature.partId.includes("countertop")
      && featureGroup.part.partId !== sqftFromFeature.cartFeature.partId) // case if 2 countertops
  )) {
    const name1 = sqftFromFeature.cartFeature.getSplittedFeatureName();
    const navItem = allNavItems.find(navItem => {
      return navItem.part.getSplittedFeatureName() === name1;
    });
    if (navItem) {
      feature = navItem.part;
    }
  }
  if (!feature && featureGroup.part.activeFeature && (!fromWizardGroupId || allNavItems.some(navItem => {
    return navItem.part.dbFeature.sharedFeatureName === featureGroup.part.activeFeature.dbFeature.sharedFeatureName
  }))) {
    feature = featureGroup.part.activeFeature;
  }
  if (!feature && featurePassed.featureId) {
    // we added a real feature with id - go and find it - cases when we load feature from different visualizer
    const allNavItems2 = layout.designNavigationItems(featureGroup, {}, "", false, "all", [], {returnAllFeatures: true});
    const foundNavItem = allNavItems2.find(nItem => nItem.part.dbFeature.id === featurePassed.featureId);
    if (foundNavItem) {
      feature = foundNavItem.part;
    }
  }
  if (!feature && allNavItems.length) {
    feature = allNavItems[0].part;
  }

  return [feature, isSqftFromFeature, isFromCartFeatureAdded, featurePassed.fromWizardGroupId];
}
